/* eslint-disable jsx-a11y/anchor-is-valid */

import React, {useState} from 'react'
import {useIntl} from 'react-intl'
import {CardLoading} from '../../../../../../../../../_metronic/partials/widgets/loading/CardLoading'
import {KTSVG} from '../../../../../../../../../_metronic/helpers'
import {ModalFields} from '../modal/ModalFields'
import {ModalUsersResp} from '../modal/ModalUsersResp'
import {ModalEnterprises} from '../modal/ModalEnterprises'

type Props = {
  className: string
  licenseNumber: string
  fields: any
  entrepreneur: string
  issueOrgan: string
  responsibles: any
  file: string
  enterprises: any
}

const CardSystemWidgetOneLicense: React.FC<Props> = ({
  className,
  fields,
  entrepreneur,
  issueOrgan,
  responsibles,
  licenseNumber,
  file,
  enterprises,
}) => {
  const intl = useIntl()
  const [showEnterprisesModal, setShowEnterprisesModal] = useState<boolean>(false)
  const [showFieldsModal, setFieldsModal] = useState<boolean>(false)
  const [showResponsiblesModal, setResponsiblesModal] = useState<boolean>(false)

  return (
    <div
      className={`card w-100 h-100 ${className} 
          border          
          border-gray-300                   
          `}
    >
      {/* begin::Body */}
      <div className='card-body d-flex flex-column py-xxl-3 py-lg-0'>
        {licenseNumber ? (
          <>
            {/* begin::Row */}
            <div className='row  mb-xxl-3 mt-xxl-1 mb-lg-3'>
              {/* begin::Col */}
              <p className='fw-bold fs-4 mt-2'>
                {intl.formatMessage({id: 'LICENSES.TITLE_STEAP1'})}
              </p>
              <div className='col-xl-4 fs-8 fw-bold '>
                {intl.formatMessage({id: 'LICENSES.NUMBER'})}
                {file ? (
                  <a href={file} target='_blank' rel='noreferrer' title='Visualizar PDF Licença'>
                    <div className='text-primary'>{licenseNumber}</div>
                  </a>
                ) : (
                  <div className='text-primary fs-8'>{licenseNumber}</div>
                )}
              </div>
              <div className='col-xl-4 text-center fs-8 fw-bold '>
                {intl.formatMessage({id: 'ENTERPRISES.INPUT_FIELDS'})}
                <p className='text-primary fs-8'>
                  {fields?.length}
                  <a
                    href='#'
                    onClick={() => setShowEnterprisesModal(true)}
                    data-bs-toggle='modal'
                    data-bs-target='#kt_modal_fields'
                    type='button'
                  >
                    <KTSVG
                      path='/media/icons/duotune/general/gen044.svg'
                      className='svg-icon-muted svg-icon p-1 text-primary'
                    />
                  </a>
                </p>
                {fields ? (
                  <>
                    <ModalFields
                      id='fieldsModal'
                      show={showFieldsModal}
                      handleClose={() => setFieldsModal(false)}
                      fields={fields}
                    />
                  </>
                ) : (
                  ''
                )}
              </div>
              <div className='col-xl-4 text-center fs-8 fw-bold '>
                {intl.formatMessage({id: 'ENTREPRENEUR.ENTREPRENEUR_SINGLE'})}
                <div className='text-primary text-primary fs-9'>{entrepreneur}</div>
              </div>
              <div className='col-xl-4  fs-8 fw-bold '>
                {intl.formatMessage({id: 'ISSUE_ORGANS.TITLE'})}

                <div className='text-primary  fs-9'>{issueOrgan}</div>
              </div>
              <div className='col-xl-4 text-center fs-8 fw-bold '>
                {intl.formatMessage({id: 'USERS.RESPONSIBLE'})}
                <p className='text-primary fs-8'>
                  {responsibles?.length}
                  <a
                    href='#'
                    onClick={() => setShowEnterprisesModal(true)}
                    data-bs-toggle='modal'
                    data-bs-target='#kt_modal_users'
                    type='button'
                  >
                    <KTSVG
                      path='/media/icons/duotune/general/gen044.svg'
                      className='svg-icon-muted svg-icon p-1 text-primary'
                    />
                  </a>
                </p>
                {responsibles ? (
                  <>
                    <ModalUsersResp
                      id='responsiblesModal'
                      show={showResponsiblesModal}
                      handleClose={() => setResponsiblesModal(false)}
                      reponsables={responsibles}
                    />
                  </>
                ) : (
                  ''
                )}
              </div>
              <div className='col-xl-4 text-center fs-8 fw-bold '>
                {intl.formatMessage({id: 'ENTERPRISES.TITLE'})}

                <p className='text-primary fs-8'>
                  {enterprises?.length}
                  <a
                    href='#'
                    onClick={() => setShowEnterprisesModal(true)}
                    data-bs-toggle='modal'
                    data-bs-target='#kt_modal_enterprises'
                    type='button'
                  >
                    <KTSVG
                      path='/media/icons/duotune/general/gen044.svg'
                      className='svg-icon-muted svg-icon p-1 text-primary'
                    />
                  </a>
                </p>
                {enterprises ? (
                  <>
                    <ModalEnterprises
                      id='enterprisesModal'
                      show={showEnterprisesModal}
                      handleClose={() => setShowEnterprisesModal(false)}
                      enterprises={enterprises}
                    />
                  </>
                ) : (
                  ''
                )}
              </div>
            </div>
          </>
        ) : (
          <CardLoading />
        )}
      </div>
      {/* end::Body */}
    </div>
  )
}

export {CardSystemWidgetOneLicense}
